module.exports = __webpack_public_path__ + "stu-res/img/icon-1024@3x.679ede56.png";